import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      alignItems: 'center',
      display: 'flex',
      color: theme.palette.error.main,
      fontSize: theme.typography.pxToRem(12),
      marginTop: 2,
      marginLeft: 0,
      '& span': {
        marginLeft: 5,
      },
    },
  };
});

export default useStyles;
